export const races = [
  { id: 1, race: 'American Indian or Alaska Native' },
  { id: 2, race: 'Asian' },
  { id: 3, race: 'Black or African American' },
  { id: 4, race: 'Native Hawaiian or Other Pacific Islander' },
  { id: 5, race: 'White' },
];
